module.exports = __webpack_public_path__ + "img/comention_dist.82ddbd15.png";